import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveIdentityProvidersRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveIdentityProvidersRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveIdentityProvidersRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getIdentityProviders() {
      return getState().identityProviders;
    },
  };
}

export { createSelector };
